import styled from 'styled-components';

export const StyledSessionTimeoutModal = styled.div`

`;
